import {Pagination, Table, Tag} from "antd";
import {
	renderDate,
	numberFormat,
} from "~/utils";
import PendingReceiptAction from "./PendingReceiptAction";
import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";
import {useUtilities} from "~/hooks";

function PendingReceiptTable({items = [], pagination, onPaginationChange, setItemEdit, openModal}) {

	const {tableHeight} = useContext(AppContext);

	const {utilities} = useUtilities();

	const handleEditClick = (item) => {
		setItemEdit(item);
		openModal('addEdit');
	}

	const handleResolveClick = (item) => {
		setItemEdit(item);
		openModal('resolve');
	}

	const handleDeleteClick = (item) => {
		setItemEdit(item);
		openModal('delete');
	}

	const paymentLabels = {
		'cod'    : 'Tiền mặt',
		'bank'   : 'Chuyển khoản',
		'momo'   : 'Ví Momo',
		'swipe'  : 'Pos',
	};

	const columns = [
		{ title: 'Mã', dataIndex: 'code', key: "code", width: '90px', render: (_, item) => (<div>TCD{item?.id}</div>)},
		{ title: 'Ngày nhận', dataIndex: 'time', key: "time", width: '120px', render: (_, item) => (<div><p>{renderDate(item?.time)}</p></div>)},
		{ title: 'Số tiền', dataIndex: 'price', key: "price", width: '160px', render: (_, item) => (<p><b>{numberFormat(item?.price)}đ</b></p>)},
		{ title: 'Phương thức', dataIndex: 'paymentMethod', key: "paymentMethod", width: '150px', render: (_, item) => (
			<div>
				<p>{paymentLabels[item?.paymentMethod] || item?.paymentMethod || '--'}</p>
				{item?.paymentMethod === 'bank' && item?.bankAccount && (
					<p style={{fontSize: '12px', color: '#888'}}>{utilities.bankAccounts?.[item.bankAccount]?.title || item.bankAccount}</p>
				)}
			</div>
		)},
		{ title: 'Người gửi / Nội dung', dataIndex: 'payerName', key: "payerName", width: '200px', render: (_, item) => (item?.payerName || '--')},
		{ title: 'Ghi chú', dataIndex: 'note', key: "note", width: '200px', render: (_, item) => (item?.note || '--')},
		{ title: 'Trạng thái', dataIndex: 'status', key: "status", width: '160px', render: (_, item) => (
			<div>
				<Tag color={item?.status?.badge === 'green' ? 'green' : 'gold'}>{item?.status?.label || 'Chờ xác định'}</Tag>
				{item?.status?.key === 'resolved' && item?.resolvedNote && (
					<p style={{fontSize: '12px', color: '#888', marginTop: '4px'}}>{item.resolvedNote}</p>
				)}
			</div>
		)},
		{ title: '#', dataIndex: 'action', key: "action", width: '150px', render: (_, item) => (
			<PendingReceiptAction
				key={item.id}
				item={item}
				onClickEdit={handleEditClick}
				onClickResolve={handleResolveClick}
				onClickDelete={handleDeleteClick}
			/>
		)},
	];

	const dataSource = items.map(row => ({
		key: row.id,
		...row
	}));

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table columns={columns} dataSource={dataSource} scroll={{ y: tableHeight, x: 'max-content' }} pagination={false} />
			</div>
			<Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.total} onChange={onPaginationChange} showSizeChanger={false} />
		</div>
	)
}

export default PendingReceiptTable;
